// Sorts the deal's hotels: first the hotels from `order` (in that order), then
// every other hotel in its original order. Nothing is dropped; unknown and
// duplicate ids in `order` are skipped. Without an order the input list is
// returned unchanged.
export function orderHotels(hotels, order) {
  const list = Array.isArray(hotels) ? hotels : [];
  if (!Array.isArray(order) || order.length === 0) return list;
  const byId = new Map();
  for (const h of list) {
    if (h && !byId.has(h.hotel_id)) byId.set(h.hotel_id, h);
  }
  const used = new Set();
  const first = [];
  for (const id of order) {
    const h = byId.get(id);
    if (!h || used.has(id)) continue;
    used.add(id);
    first.push(h);
  }
  if (first.length === 0) return list;
  return [...first, ...list.filter((h) => !(h && used.has(h.hotel_id)))];
}
